module.exports = __webpack_public_path__ + "img/mission2.0a55c292.png";